import React from 'react';
import Link from 'gatsby-link';

import styles from './Apprenticeship.module.scss';

const Apprenticeship = (props) => (
  <div className={styles.Apprenticeship} id={props.identifier}>
    <div className={styles.Apprenticeship__Wrapper}>
      <h2>{props.title}</h2>
      {
          props.intro &&
          <p className={`${styles.Apprenticeship__Intro}`}>{ props.intro.apprenticeshipIntro }</p>
      }
      <div className={styles.Cards}>
        {props.cards.map((card, i) =>
            <div key={i}>
            {
                card.link &&
                <div className={`${styles.Cards__Item} apprenticeships-card`}>
                    <a href={ `/${card.link }/` } target="_blank" className={`${styles.Cards__Link}`}></a>
                    <h3>{card.title}</h3>
                    <p>{card.text.text}</p>
                </div>
            }
            {
                !card.link &&
                <div className={`${styles.Cards__Item} apprenticeships-card`}>
                    <h3>{card.title}</h3>
                    <p>{card.text.text}</p>
                </div>
            }
            </div>
        )}
      </div>
    </div>
  </div>
)

export default Apprenticeship;



// WEBPACK FOOTER //
// ./src/components/Destination/Apprenticeship/index.js